import { debounce } from 'lodash';
export default {
    methods: {
        initForFullNotes($_day, scrollToTop = true) {
            // **** Для рендера берем по диапозону из локального хранилища ****
            // Смотрим диапозон от onViewNote
                // Смотрим есть ли что в рамках диапозона в filledNotesStorage
                // Если есть - огонь - рендер
                // Если нет - идем в рамках диапозона на сервер 
                // Заполняем filledNotesStorage
            
            
            this.notFullNotes = false // Сообщение "НЕТ ЗАПОЛНЕННЫХ ЗАМЕТОК"
            this.observing(false) // Отписываемся от наблюдателей
            this.showingFullNotes = true // Включаем режим только заполненных заметок
            this.clientNotes = [] // Очищаем заметки
            
            let _start = this.createDay($_day, -5) // Начало диапозона
            let _end = this.createDay($_day, 5) // Конец диапозона
            
            let _scrDay = null
            switch (scrollToTop) { // Проверяем направление движения 
                case 'today':
                    _scrDay = $_day
                    break;
                case true:
                    _scrDay = this.createDay($_day, 1)
                    break;
                case false:
                    _scrDay = this.createDay($_day, -1)
                    break;
            }
            // let _prevDay = this.createDay($_day, -1) // Начало диапозона
            this.inViewNote = $_day // Наблюдаемый элемент
            // Срабатывает при переключении режима - первый раз
            this.getNotesByRangeFull(_start, _end).then((data)=>{ 
                // Сохраняем пагинацию
                this.maxDateNextPage = store.getters['GET_MAX_DATE_NOTES'].next
                this.minDateNextPage = store.getters['GET_MIN_DATE_NOTES'].next
                Object.keys(data).map(key => {
                    this.filledNotesStorage[data[key].date] = data[key] // Наполняем хранилище заметками
                })
                let _out = this.getFillNotesByRangeFromLocal(_start, _end) // Берем из хранилища
                this.clientNotes = { ..._out } // Рендерим
                this.$nextTick(() => {
                    this.scrollToNote(_scrDay, true)
                })
            })
            
            // this.getNotesByRangeFull(_prevDay, $_day).then((data) => {
            //     // Записываем следующие страницы пагинации
            //     let _minDate = store.getters['GET_MIN_DATE_NOTES']
            //     let _maxDate = store.getters['GET_MAX_DATE_NOTES']
            //     this.minDateNextPage = _minDate.next // След страница
            //     this.maxDateNextPage = _maxDate.next // Пред страница
            //     _scrDay = _minDate.results[0].date // День к которому скроллить
            //     // Пишем в хранилище
            //     //this.clientNotes = data 
            //     this.filledNotesStorage = data
            //     // Подставляем для отрисовки - рендерим
            //     this.$nextTick(() => {
            //         this.scrollToNote(_scrDay, true)
            //     })
            // })
        },
        getFillNotesByRangeFromLocal(_start, _end) {
            // *** Вернуть по диапозону из хэш карты *** 
            // Будем использовать для рендера
            if (Object.keys(this.filledNotesStorage).length !== 0) { // Если там не пусто
                let _out = this.fillDatesRange(_start, _end) // Сделали пустую хеш карту по диапозону
                Object.keys(_out).map((key) => {
                    if(this.filledNotesStorage[key]) {
                        _out[key] = this.filledNotesStorage[key] // Заполняем диапозон с пустыми
                    } else {
                        delete _out[key]
                    }
                })
                return _out
            } else {
                return false
            }
        },
        getNotesByRangeFull(_start, _end) { // След страницы для полных заметок
            // *** Возвращает хэш карту с заполненными диапозонами *** //
            return new Promise((resolve, reject) => {
                store.dispatch('INIT_FOR_FULL_NOTES', { max: _start, min: _end }).then(() => {
                    let _out = {}
                    let _allNotes = store.getters['GET_ALL_NOTES'] // Получили существующие заметки по диапозону
                    if (_allNotes.length !== 0) { // Если там не пусто
                        _allNotes.sort((a,b)=>{
                            if(a.date > b.date) {return -1}
                            if (a.date < b.date) { return 1 }
                            return 0
                        }).map(note=>{
                            _out[note.date] = note
                        })
                        this.topNote = _allNotes[_allNotes.length-1].date
                        this.bottomNote = _allNotes[0].date
                        resolve(_out)
                    } else {
                        this.fullNotesTopEnd = true
                        this.fullNotesBottomEnd = true
                        this.notFullNotes = true
                    }
                }).catch((error) => {
                    reject(error)
                })
            })
        },
    
    getNextForFullNotes() {
        // Проверяем есть ли пагинация
            // Если есть пагинация - заполняем хранилище
            // Если нет - говорим что в будущем больше нету заметок
        if (this.minDateNextPage) {
            this.observing(false) // Отписываемся от наблюдателей
            // this.loadingReady = false
            // this.loadingPagination = false
            store.dispatch('SET_NEXT_PAGE_FOR_MIN_DATE', this.minDateNextPage).then(() => {
                // this.nextPageHash = []
                let _notes = store.getters['GET_MIN_DATE_NOTES'];
                _notes.results.map((note) => {
                    this.filledNotesStorage[note.date] = note
                })
                // // let _dates = Object.keys(this.nextPageHash).sort() 
                // let _res = { ...this.nextPageHash }
                // let _ordered = {}
                // Object.keys(_res).sort((a, b) => {
                //     if (a < b) {
                //         return 1
                //     } else if (a > b) {
                //         return -1
                //     } else {
                //         return 0
                //     }
                // }).map(function (key) {
                //     _ordered[key] = _res[key];
                // });
                
                //Рендер
                let _forRender = this.getFillNotesByRangeFromLocal(this.bottomNote, this.topNote)
                this.clientNotes = { ..._forRender, ...this.clientNotes }
                // Scroll
                // this.$nextTick(() => {
                //     this.scrollToNote(_notes.results[0].date)
                //     this.topNote = _notes.results[_notes.results.length - 1].date
                // })
                this.minDateNextPage = _notes.next; // Пагинация
            })
            .catch(e => {
                throw new Error(
                    'action dispatch SET_NEXT_PAGE_FOR_MIN_DATE error ',
                    e
                );
            });
        } else {
            let _forRender = this.getFillNotesByRangeFromLocal(this.bottomNote, this.topNote)
            this.clientNotes = { ..._forRender, ...this.clientNotes }
            this.$dmsSuccessNoty('На будущее больше нет заметок');
            this.fullNotesTopEnd = true
        }
    },
    getPrevForFullNotes() {
        if (this.maxDateNextPage) {
            this.observing(false) // Отписываемся от наблюдателей
            store.dispatch('SET_NEXT_PAGE_FOR_MAX_DATE', this.maxDateNextPage).then(() => {
                    let _notes = store.getters['GET_MAX_DATE_NOTES'];
                    _notes.results.map(note => {
                        this.prevPageHash[note.date] = note;
                    });
                    // Создаем массив дат по диапозону -ф
                    let _dates = Object.keys(this.prevPageHash).sort()
                    
                    // Делаем слияниие
                    let _res = { ...this.prevPageHash }
                    let _ordered = {}
                    Object.keys(_res).sort((a, b) => {
                        if (a < b) {
                            return 1
                        } else if (a > b) {
                            return -1
                        } else {
                            return 0
                        }
                    }).map(function (key) {
                        _ordered[key] = _res[key];
                    });
                    // //Рендер
                    this.clientNotes = { ...this.clientNotes, ..._ordered }
                    // Scroll
                    this.$nextTick(() => {
                        this.scrollToNote(_notes.results[_notes.results.length-1].date)
                        this.bottomNote = _notes.results[0].date
                    })
                    this.maxDateNextPage = _notes.next;
                })
                .catch(e => {
                    throw new Error(
                        'action dispatch SET_NEXT_PAGE_FOR_MIN_DATE error ',
                        e
                    );
                });
        } else {
            this.$dmsSuccessNoty('В прошлом больше нет заметок');
            this.fullNotesBottomEnd = true
        }
    },
    
}
}


// WEBPACK FOOTER //
// ./src/apps/bpm/notes/mixins/filledNotes.js